import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";

import PortletWrapper from "../misc/PortletWrapper";
import MarginWrapper from "../misc/MarginWrapper";
import TextHeader from "../misc/TextHeader";
import GoogleReviews from "../misc/GoogleReviews";
import DetailsInfo from "./DetailsInfo";
import DetailsMap from "./DetailsMap";
import BranchEmployees from "./BranchEmployees";

const Notice = styled.div`
    color: white;
    background: #ff6c0e;
    padding: 10px;
    margin-bottom: 20px;
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const LeftCol = styled.div`
    flex: 1;
    margin-bottom: 20px;
`;

const RightCol = styled.div`
    flex: 2;
    min-height: 350px;
    min-width: 350px;
    @media (max-width: 737px) {
        min-width: 100%;
    }
`;

const Details = ({ location }) => (
    <PortletWrapper>
        <Helmet>
            <title>{location.seotitle}</title>
            <meta property="og:title" content={location.ogtitle} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:description" content={location.ogdescription} />
            <meta name="keywords" content={location.seokeywords} />
            <meta name="description" content={location.seodescription} />
        </Helmet>

        <TextHeader heading={location.name} />
        <MarginWrapper>
            {location.noticeforbranchhtmltext && (
                <Notice
                    dangerouslySetInnerHTML={{
                        __html: location.noticeforbranchhtmltext
                    }}
                />
            )}
            <Wrapper>
                <LeftCol>
                    <DetailsInfo location={location} />
                </LeftCol>
                <RightCol>
                    <DetailsMap location={location} />
                </RightCol>
            </Wrapper>
            {
                location.branchEmployees && location.branchEmployees.length > 0 && 
                <BranchEmployees location={location} />
            }
            {location.elfsight_id && <GoogleReviews elfsight_id={location.elfsight_id}></GoogleReviews>}
        </MarginWrapper>
    </PortletWrapper>
);

export default Details;



// WEBPACK FOOTER //
// ./components/details/Details.jsx